import React, { Component } from "react";
import {
    Icon
} from "@shopify/polaris";
import {
    CancelMajor
} from '@shopify/polaris-icons';
import "./index.css";
// import Language from "../../i18n/Language";
// const t = Language

class ViewImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imgUrl: this.props.imgUrl
        }
    }

    render() {
        const {
            state: {
                imgUrl
            },
        } = this;

        return (
            <div className="view-image-container" onClick={this.props.closeImageShow}>
                <img alt="viewImageUrl" className="view-image-url" src={imgUrl} />
                <img alt="loadImg" className="loadImg init-image" src="/load_img.png" />
                <img alt="loadImg" className="loadImg load-image" src="/loading.gif" />

                <div className="close-view"><Icon source={CancelMajor} /></div>
            </div>
        );
    }
}

export default ViewImage;